module.exports = __webpack_public_path__ + "img/Hunter-troll-f-70.05ba5c75.gif";